import { Calendar, Bot } from "lucide-react";
import { Link } from "react-router-dom";
import campaignArtwork from "@/assets/campaign/autonomous-workforce-campaign.webp";
import { Button } from "./ui/button";

const bookingUrl = "https://api.leadconnectorhq.com/widget/bookings/neilaipudurobotics";

const HeroSection = () => {
  return (
    <section aria-labelledby="hero-heading" className="w-full bg-[#030913]">
      <img
        src={campaignArtwork}
        alt="Neil AI Global Solutions autonomous workforce campaign featuring commercial cleaning, delivery, service, humanoid, quadruped and landscape robots."
        width={1672}
        height={941}
        sizes="100vw"
        loading="eager"
        decoding="async"
        {...({ fetchpriority: "high" } as React.ImgHTMLAttributes<HTMLImageElement>)}
        className="block h-auto w-full"
      />

      <div className="mx-auto max-w-4xl px-4 py-7 text-center sm:px-6 sm:py-9 md:py-11">
        <h1 id="hero-heading" className="font-orbitron text-[1.35rem] font-bold leading-tight text-white min-[390px]:text-2xl sm:text-3xl md:text-5xl">
          <span className="block sm:inline">Build Your Autonomous</span>{" "}
          <span className="block sm:inline">Workforce</span>
        </h1>
        <p className="mx-auto mt-3 max-w-3xl text-sm leading-relaxed text-slate-300 sm:text-base md:text-lg">
          Commercial robotics, artificial intelligence, and Robotics-as-a-Service for your business.
        </p>
        <div className="mx-auto mt-6 flex max-w-xl flex-col justify-center gap-3 sm:flex-row">
          <Button asChild size="lg" className="min-h-[52px] w-full rounded-xl px-7 font-bold shadow-[0_0_28px_hsl(var(--primary)/0.3)] sm:w-auto">
            <Link to="/robots" className="inline-flex items-center justify-center gap-2">
              <Bot className="h-5 w-5" aria-hidden="true" />
              Explore Our Robots
            </Link>
          </Button>
          <Button asChild size="lg" variant="outline" className="min-h-[52px] w-full rounded-xl border-[#b99751]/70 px-7 font-bold text-white hover:bg-[#b99751]/10 sm:w-auto">
            <a href={bookingUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2">
              <Calendar className="h-5 w-5 text-[#d7b96f]" aria-hidden="true" />
              Book a Demo
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;